module.exports = __webpack_public_path__ + "static/img/single_content_bg1.7d86b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/single_content_bg1.png
// module id = /J4i
// module chunks = 1